import { createFileRoute } from '@tanstack/react-router';
import { ContestEditFixturesStep } from '../pages/contests/edit/contest-edit-fixtures-step';

export const Route = createFileRoute('/contests/$id/edit/fixtures')({
  component: ContestEditFixturesStep,
});
